import React from 'react';
import { Drawer, IconButton, Link, Box } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import DrawerHeader from './DrawerHeader';
import MenuList from './MenuList';
import DrawerUserInfoContainer from '../../../containers/common/header/DrawerUserInfoContainer';

import { Link as RouterLink } from 'react-router-dom';

const LeftDrawer = ({
  drawerWidth,
  open,
  handleDrawerClose,
  variant = 'persistent',
  onMenuSelect,
  focusSearchToken,
}) => {
  const handleLogoClick = () => {
    if (onMenuSelect) {
      window.setTimeout(onMenuSelect, 0);
    }
  };

  return (
    <Drawer
      sx={{
        width: variant === 'persistent' ? drawerWidth : 'auto',
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          maxWidth: '86vw',
          boxSizing: 'border-box',
        },

      }}
      variant={variant}
      anchor="left"
      open={open}
      onClose={handleDrawerClose}
    // PaperProps={{
    //   sx: {
    //     backgroundColor: "#37474f",
    //     color: "#eceff1",
    //   }
    // }}
    >
      <DrawerHeader sx={{ backgroundColor: '#fafafa' }}>
        <Box sx={{ px: 1 }}>
          <Link component={RouterLink} to="/" onClick={handleLogoClick}>
            <img src="/static/images/logo/logo.png" alt="companyLogo" style={{ width: 100 }} />
              </Link>
        </Box>
        <IconButton onClick={handleDrawerClose} sx={{ color: '#37474f' }}>
          <MenuOpenIcon />
        </IconButton>
      </DrawerHeader>

      <DrawerUserInfoContainer />

      <MenuList onMenuSelect={onMenuSelect} focusSearchToken={focusSearchToken} />
    </Drawer>
  )
}

export default LeftDrawer
